import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import AppanCourierLogo from "../../assets/Appan Courier Logo.png";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const OrderStickerReceipt = ({ show, handleClose, receiptData }) => {
  const printableRef = useRef(null);

  useEffect(() => {
    if (show) document.body.style.overflow = "hidden";
    return () => (document.body.style.overflow = "");
  }, [show]);

  if (!show) return null;

  const data = receiptData || {
    // -------------------
    // 💾 Dummy Parcel Data
    // -------------------
    companyName: "APPAN TECH COURIER",
    companyAddress: "Thane (W), Maharashtra",
    companyContact: "+91 90225 79768",
    trackingNumber: "APN9876543210",
    orderId: "ORD-55662",
    consignorName: "Rohit Sharma",
    consignorAddress: "Shop 4, Vrindavan Complex, Thane West",
    consignorContact: "9876543210",
    consigneeName: "Aman Jain",
    deliveryAddress:
      "Flat 202, Green Residency, Near Dmart, Andheri East, Mumbai",
    returnAddress: "Appan Tech Hub, Thane West",
  };

  // ──────── DOWNLOAD PDF (fixed & optimized) ────────
  const handleDownloadPDF = async () => {
    if (!printableRef.current) return;

    try {
      const canvas = await html2canvas(printableRef.current, {
        scale: 2,
        useCORS: true, // for external images / logo
        backgroundColor: "#ffffff",
        logging: false,
      });

      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
      });

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = pdfWidth - 20; // 10mm margin on each side
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(imgData, "PNG", 10, 10, imgWidth, imgHeight);
      pdf.save(`Sticker_${data.ourWaybillNumber}.pdf`);
    } catch (err) {
      console.error("PDF generation error:", err);
      alert("Download failed. Try printing instead.");
    }
  };

  const deliveryAddress = `${data?.consigneeAddress1}, ${data?.consigneeCity}, ${data?.consigneeState}, ${data?.consigneeCountry}, ${data?.consigneePincode}`;

  const consignorAddress = `${data?.consignorAddress1}, ${data?.consignorCity}, ${data?.consignorState}, ${data?.consignorCountry}, ${data?.consignorPincode}`;

  const creatorAddress = `${data?.customerAddress1}, ${data?.customerAddress2}, ${data?.customerAddress3}, ${data?.consignorCountry}, ${data?.consignorPincode}`;

  return createPortal(
    <div
      id="stk-overlay"
      className="fixed inset-0 z-50 flex items-center justify-center bg-black rounded-xl shadow-2xl border border-gray-200 bg-opacity-50 p-6"
    >
      {/* PRINT STYLES */}
      <style>{`
  @media print {
    body * { visibility: hidden; }
    #sticker-wrapper, #sticker-wrapper * {
      visibility: visible;
    }
    #sticker-wrapper {
      position: absolute;
      left: 0; top: 0;
      width: 100%;
      padding: 12px;
      background: white !important;
    }
    .no-print { display: none !important; }
  }
`}</style>

      {/* Sticker Container */}
      <div
        ref={printableRef}
        id="sticker-wrapper"
        className="w-full max-w-xl bg-white border border-gray-300 rounded-xl shadow-lg p-4"
      >
        {/* Company Header */}
        {/* <div className="border-b border-gray-300 pb-2 mb-3">
          <div className="text-lg font-bold text-gray-900">
            {data.companyName}
          </div>
          <div className="text-xs text-gray-600">
            {data.companyAddress}
            <br />
            {data.companyContact}
          </div>
        </div> */}

        <div
          id="printable-receipt"
          className="w-full max-w-4xl mx-auto  overflow-y-auto max-h-[90vh]"
        >
          <div className="flex items-center gap-2 mb-3">
            <img
              src={AppanCourierLogo}
              alt="courier-logo"
              className="w-[80px] h-[60px] rounded-xl flex-shrink-0"
            />
            <div className="flex flex-col">
              <div className="font-bold text-gray-900 text-[14px]">
                {data.retailerName}
              </div>
              <div className="text-xs text-gray-500 leading-tight mt-1">
                {creatorAddress}
                <br />
                {/* Phone: {data.creatorMobile} / Email: {data.creatorEmail} */}
                {data.creatorMobile} / {data.creatorEmail}
              </div>
            </div>
          </div>
        </div>

        {/* Tracking Number (Large) */}
        <div className="mb-2 flex items-center justify-between gap-2">
          <div className="flex items-start gap-2">
            <div className="text-xs font-semibold text-gray-500">
              Waybill Number:
            </div>
            <div className="text-xs font-bold text-black tracking-wide">
              {data.ourWaybillNumber}
            </div>
          </div>
          <p className="text-xs font-semibold text-gray-500">
            Date: {data?.date}
          </p>
        </div>

        {/* Barcode Placeholder */}
        {/* <div className="w-full h-14 border border-gray-400 rounded-md mb-4 flex items-center justify-center text-gray-500 text-sm">
          BARCODE HERE
        </div> */}

        {/* Consignee */}
        <div className="mb-2">
          <div className="text-xs font-bold text-gray-700">
            To (Consignee): {data.consigneeName}
          </div>
          <div className="text-xs text-gray-700">{deliveryAddress}</div>
        </div>

        {/* Consignor */}
        <div className="mb-2">
          <div className="text-xs font-bold text-gray-700">
            From (Consignor): {data.consignorName}
          </div>
          <div className="text-xs text-gray-700">{consignorAddress}</div>
          <div className="text-xs text-gray-700">{data.consignorMobile}</div>
        </div>

        {/* Return Address */}
        <div className="mb-4">
          <div className="text-xs font-semibold text-gray-500">
            Return Address:
          </div>
          <div className="text-xs text-gray-700">{creatorAddress}</div>
        </div>

        {/* Buttons */}
        <div
          className="no-print flex justify-center gap-3 pt-2"
          data-html2canvas-ignore="true"
        >
          <button
            onClick={handleDownloadPDF}
            className="px-4 py-2 bg-blue-600 text-white text-sm rounded-lg shadow hover:bg-blue-700 transition flex items-center gap-2"
          >
            Download PDF
          </button>
          <button
            onClick={() => window.print()}
            className="px-4 py-2 bg-orange-500 text-white text-sm rounded-lg shadow hover:bg-orange-600"
          >
            Print
          </button>

          <button
            onClick={handleClose}
            className="px-4 py-2 bg-gray-300 text-gray-900 text-sm rounded-lg shadow hover:bg-gray-400"
          >
            Close
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default OrderStickerReceipt;
